import { render, staticRenderFns } from "./chatMessageItem.vue?vue&type=template&id=4f08b33f&scoped=true"
import script from "./chatMessageItem.vue?vue&type=script&lang=ts"
export * from "./chatMessageItem.vue?vue&type=script&lang=ts"
import style0 from "./chatMessageItem.vue?vue&type=style&index=0&id=4f08b33f&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f08b33f",
  null
  
)

export default component.exports